import { useFetchNfe } from "hooks";
import { cleanObject } from "utils";
import { getURLWithParams } from "utils/context";

export const useCfopCstsParties = params =>
  useFetchNfe(
    params
      ? getURLWithParams("/reports/cfops-csts/parties", cleanObject(params))
      : null,
  );

export const useCfopCstsPartyNotas = params =>
  useFetchNfe(
    params
      ? getURLWithParams(
          "/reports/cfops-csts/parties/notas",
          cleanObject(params),
        )
      : null,
  );

export const useCfopCstsNotaProdutos = params =>
  useFetchNfe(
    params
      ? getURLWithParams(
          "/reports/cfops-csts/notas/produtos",
          cleanObject(params),
        )
      : null,
  );
